<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Cadastrar Acolhimento") }}
    </h1>

    <form @submit.prevent="submit" ref="addItem">

        <div class="row" v-if="!veioGestaoVagas">
          <div class="col-12">
            <h4 class="font-weight-bold">
              Tipo de acolhimento:
            </h4>
          </div>

          <form-radio
            grid="12"
            name="tipo_acolhimento"
            v-model="situacao_usuario"
            :itens="options_radio"
          />
        </div>

        <div class="row">
            <div class="col-md-4">
                <form-select 
                    label="Origem da Solicitação" 
                    :itens="$root.arrays.acolhimento_origem_solicitacao" 
                    v-model="item.origem_solicitacao_id" 
                    :required="true" 
                />
            </div>
            <div class="col-md-4">
                <form-select 
                    label="Unidade solicitante" 
                    :itens="unidades"
                    v-model="item.unidade_solicitante" 
                    :required="true" 
                />
            </div>
            <div class="col-md-4">
                <form-select 
                    label="Serviço socioassistencial" 
                    :itens="servicos"
                    v-model="item.servico_socioassistencial_id" 
                    :required="true" 
                />
            </div> 
        </div>

        <div class="row">
            <div class="col-md-12">
                <form-input type="text" v-model="item.desc_origem_solicitacao" label="Descrição da Origem da Solicitação" v-show="mostrarDescricaoOrigemSolicitacao" :required="mostrarDescricaoOrigemSolicitacao"/>
            </div> 
        </div>

        <div class="row">
            <div
                :class="{
                    'col-md-8': situacao_usuario && !veioGestaoVagas,
                    'col-md-4': !situacao_usuario || veioGestaoVagas
                }"
            >
                <form-input
                    v-if="veioGestaoVagas"
                    label="Nome completo do usuário"
                    v-model="item.nome_acolhido"
                    :required="true"
                />

                <form-select
                    v-else-if="situacao_usuario"
                    ref="select"
                    label="Nome completo do usuário"
                    placeholder="Digite o nome do usuário"
                    v-model="item.usuario_id"
                    :itens="pessoas"
                    @search="metodoBuscaUsuario"
                    :loading="loadingUsuarios"
                    :required="true"
                />

                <form-input
                    v-else
                    label="Nome completo do usuário"
                    v-model="item.nome_acolhido"
                    :required="true"
                />
            </div>
            <div class="col-md-4">
                <form-input label="Nome social" v-model="item.nome_social" />
            </div>
            <div class="col-md-2">
                <form-input label="Data de nascimento" v-model="item.nascimento" type="date" :required="true"/>
            </div>
            <div class="col-md-2">
                <form-input label="Número do CPF" v-model="item.cpf" v-mask="'###.###.###-##'"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2"> 
                <form-select label="Sexo" :itens="$root.arrays.sexo" v-model="item.sexo_id" :required="true"/>
            </div>
            <div class="col-md-2">
                <form-select label="Gênero" :itens="genero" v-model="item.genero_id" :required="true"/>
            </div> 
            <div class="col-md-4" v-show="mostrarDescricaoGenero">
                <form-input type="text" v-model="item.desc_genero" label="Descreva o Gênero" v-show="mostrarDescricaoGenero" :required="mostrarDescricaoGenero"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <form-select label="Pessoa com deficiência?" :itens="pergunta" v-model="item.deficiencia" :required="false" />
            </div>
            <div class="col-md-4" v-show="mostrarDeficiencia">  
                <form-select label="Em função da deficiência, requer apoio para atividades de vida diária?" :itens="pergunta" v-model="item.deficiencia_requer_apoio" v-show="mostrarDeficiencia" :required="mostrarDeficiencia"/>
            </div>
            <div class="col-md-4" v-show="mostrarDeficiencia"> 
                <form-select label="Tipo de Deficiência" :itens="$root.arrays.tipo_deficiencia" v-model="item.list_deficiencia" v-show="mostrarDeficiencia" :required="mostrarDeficiencia" :multiple="true"/>
            </div>
        </div>

        <div class="row" v-show="mostrarDescDeficiencia">
            <div class="col-md-12"> 
                <form-input label="Descreva a Deficiência" v-model="item.tipo_deficiencia" :required="mostrarDescDeficiencia"/>
            </div>
        </div>

        <div class="row" v-if="idadeIdoso >= 60">
            <div class="col-md-4" >
                <form-select label="Grau de dependência (RDC ANVISA 283/2005)" :itens="dependencia" v-model="item.grau_dependencia_id" :required="false"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <form-select label="Família com presença de criança(s) e/ou adolescente(s)?" :itens="$root.arrays.membros_na_familia" v-model="item.familia_membros" :required="true" :multiple="true"/>
            </div>
            <div class="col-md-2">
                <form-select label="Pessoa em situação de rua?" :itens="pergunta" v-model="item.situacao_rua" :required="true" value-field="id" text-field="value" />
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <form-input label="Termo Acolhimento" v-model="item.termo_acolhimento"/>
            </div>
            <div class="col-md-2">
                <form-calendar label="Data do Acolhimento" v-model="item.data_acolhimento" :required="true" :max-date="dataNow"/>
            </div>
            <div class="col-md-2">
                <form-calendar label="Horário" v-model="item.hora_acolhimento" mode="time"/>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <form-select label="Motivo(s) do Acolhimento:" :itens="$root.arrays.motivos_acolhimento" v-model="item.motivo_acolhimento" :required="true" :multiple="true"/>
            </div>
        </div>

        <div class="row" v-show="mostrarMotivoAcolhimento">
            <div class="col-lg-12">
                <form-input type="text" v-model="item.desc_motivo_acolhimento" label="Descreva o Motivo(s) do Acolhimento:" :required="mostrarMotivoAcolhimento"/>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <form-textarea-editor label="Observação sobre o acolhimento" v-model="item.observacao"/>
            </div> 
        </div>

        <div class="row">
            <div class="col-lg-12">
                <form-file @submit="submitFile" multiple btn-text="Iniciar" :progress="progressCompleted"/>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <search-tecnico :tecnicos.sync="item.tecnicos" />
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="row pt-4 px-0 d-flex justify-content-end">
                    <form-toggle grid="4" class="d-flex justify-content-end" mt="0" v-model="item.privado" label="Sigilo?" />
                    <div class="col-auto px-2 text-right">
                        <a class="btn btn-default" @click="$emit('voltar')">
                            <i class="mdi mdi-arrow-left" />
                        </a>
                        <button
                            class="btn btn-success btn-submit"
                            data-style="zoom-in"
                            type="submit"
                        >
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
    export default {
        props: ["familia", "publico_alvo"],
        name: "Add",
        data() {
            return {
                veioGestaoVagas: false,
                item: {
                    privado: false,
                    tecnicos: [],
                    unidade_acolhimento: null,
                    usuario_id: null,
                    familia_id: null,
                    nome_acolhido: '',
                    nome_social: '',
                    nascimento: '',
                    cpf: '',
                    sexo_id: null,
                    genero_id: null,
                    deficiencia: 2,
                    list_deficiencia: [],
                    situacao_rua: 2
                },
                situacao_usuario: true,
                pessoas: [],
                files: {},
                unidades: [],
                servicos: [],
                loadingCriancas: false,
                loadingIdosos: false,
                progressCompleted: 0,
                campoExtra: false,
                dataNow: moment().format("YYYY/MM/DD"),
                pergunta: this.$root.arrays.pergunta,
                genero: this.$root.arrays.genero,
                dependencia: this.$root.arrays.acolhimento_grau_dependencia,
                options_radio: [
                    { id: true, value: "Com cadastro" },
                    { id: false, value: "Sem cadastro" },
                ],
            };
        },
        watch: {
            'item.reincidencia'(novoValor) {
                if (novoValor !== 1) {
                    this.item.data_reincidencia = null; // ou "" se preferir string vazia
                }
            },
            idadeIdoso(novaIdade) {
                if (novaIdade < 60) {
                    this.item.grau_dependencia_id = null;
                }
            },
            'item.origem_solicitacao_id'(valor) {
                if (valor !== 17 && (!valor?.id || valor.id !== 17)) {
                    this.item.desc_origem_solicitacao = '';
                }
            },
            'item.genero_id'(valor) {
                if (valor !== 6 && (!valor?.id || valor.id !== 6)) {
                    this.item.desc_genero = '';
                }
            },
            'item.deficiencia'(valor) {
                if (valor !== 1) {
                    this.item.list_deficiencia = [];
                    this.item.desc_deficiencia = '';
                    this.item.deficiencia_requer_apoio = '';
                }
            },
            'item.list_deficiencia'(novosValores) {
                if (!novosValores?.some(opcao => opcao === "7" || opcao.id === "7")) {
                    this.item.tipo_deficiencia = '';
                }
            },
            'item.usuario_id'(usuarioId) {
                if (!usuarioId) return;

                const usuario = this.pessoas.find(pessoa => pessoa.id == usuarioId);

                if (!usuario || !usuario.id) {
                    return;
                }

                this.$set(this.item, 'familia_id', usuario.familia_id || null);
                this.$set(this.item, 'nome_acolhido', usuario.nome_completo || '');
                this.$set(this.item, 'nome_social', usuario.nome_social || '');
                this.$set(this.item, 'nascimento', usuario.data_nascimento || '');
                this.$set(this.item, 'cpf', this.formatarCpf(usuario.cpf));

                this.$set(this.item, 'sexo_id', usuario.sexo_id ? Number(usuario.sexo_id) : null);
                this.$set(this.item, 'genero_id', usuario.genero_id ? Number(usuario.genero_id) : null);

                this.$set(
                    this.item,
                    'deficiencia',
                    usuario.deficiencia ? Number(usuario.deficiencia) : 2
                );

                this.$set(
                    this.item,
                    'situacao_rua',
                    usuario.situacao_rua ? Number(usuario.situacao_rua) : 2
                );

                let deficiencias = [];

                if (usuario.list_deficiencia) {
                    deficiencias = String(usuario.list_deficiencia)
                        .split(',')
                        .filter(Boolean)
                        .map(String);
                }

                this.$set(this.item, 'list_deficiencia', deficiencias);
            }
        },
        computed: {
            mostrarDescDeficiencia(){
                return this.item.list_deficiencia?.some(opcao => opcao === "7" || opcao.id === "7");
            },
            mostrarDescricaoGenero() {
                const genero = this.item.genero_id;
                return genero === 6 || (genero?.id === 6);
            },
            mostrarDescricaoOrigemSolicitacao() {
                const origem_solicitacao = this.item.origem_solicitacao_id;
                return origem_solicitacao === 17 || (origem_solicitacao?.id === 17);
            },
            mostrarDataUltimoAcolhimento () {
                return this.item.reincidencia === 1;
            },
            mostrarDeficiencia() {
                const deficiencia = this.item.deficiencia;
                return deficiencia === 1 || (deficiencia?.id === 1);
            },
            mostrarMotivoAcolhimento() {
                return this.item.motivo_acolhimento?.some(opcao => opcao === 19 || opcao.id === 19);
            },
            idadeIdoso() {
                if (!this.item.nascimento) return 0;

                const hoje = moment();
                const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
                return hoje.diff(nascimento, "years");
            },
            metodoBuscaUsuario() {
                return this.publico_alvo === "crianca" ? this.procurarCriancas : this.procurarIdosos;
            },
            loadingUsuarios() {
                return this.publico_alvo === "crianca" ? this.loadingCriancas : this.loadingIdosos;
            },
        },
        mounted() {

            if (window.__itemParaCadastroAcolhimento) {
                this.preencherCampos(window.__itemParaCadastroAcolhimento);
                this.veioGestaoVagas = true;
            }

            this.getUnidades();

            this.getServicos();

        },
        methods: {

            mapPergunta(v) {

                const val = String(v); // transforma em string
                if (val === "1" || val === "true") return 1; // SIM
                return 2; // NÃO
                
            },

            getServicos() {
                axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
                    this.servicos = response.data;
                });
            },

            preencherCampos(dados) { 

                const normalize = (v) => {
                    if (v === true) return 1;
                    if (v === false) return 2;
                    if (v === 'null' || v === null || v === undefined) return null;
                    if (!isNaN(v)) return Number(v);
                    return v;
                };

                this.item.origem_solicitacao_id = dados.origem_solicitacao_id;
                this.item.servico_socioassistencial_id = dados.servico_socioassistencial_id;
                this.item.nome_acolhido = dados.nome_usuario;
                this.item.nome_social = dados.nome_social;
                this.item.nascimento = dados.nascimento;
                this.item.cpf = dados.cpf;
                this.item.genero_id = dados.genero_id;  
                this.item.tipo_deficiencia = dados.tipo_deficiencia !== "null" ? dados.tipo_deficiencia : null;
                
                this.item.deficiencia   = this.mapPergunta(dados.deficiencia);
                this.item.lgbt_id       = this.mapPergunta(dados.lgbt_id);
                this.item.situacao_rua  = this.mapPergunta(dados.situacao_rua);

                // Campos simples
                this.$set(this.item, 'origem_solicitacao_id', normalize(dados.origem_solicitacao_id));
                this.$set(this.item, 'servico_socioassistencial_id', normalize(dados.servico_socioassistencial_id));
                this.$set(this.item, 'nome_acolhido', dados.nome_usuario || '');
                this.$set(this.item, 'nome_social', dados.nome_social || '');
                this.$set(this.item, 'nascimento', dados.nascimento || '');
                this.$set(this.item, 'cpf', dados.cpf || '');

                // Campos de select
                this.$set(this.item, 'genero_id', Number(dados.genero_id?.id) || Number(dados.genero_id) || null);
                this.$set(this.item, 'sexo_id', normalize(dados.sexo_id));
                this.$set(this.item, 'deficiencia', this.mapPergunta(dados.deficiencia));
                this.$set(this.item, 'deficiencia_requer_apoio', this.mapPergunta(dados.deficiencia_requer_apoio));
                this.$set(this.item, 'situacao_rua', this.mapPergunta(dados.situacao_rua));

                // Outros campos
                this.$set(this.item, 'tipo_deficiencia', dados.tipo_deficiencia !== 'null' ? dados.tipo_deficiencia : null);
                this.$set(this.item, 'grau_dependencia_id', normalize(dados.grau_dependencia_id));
                this.$set(this.item, 'familia_membros', Array.isArray(dados.familia_membros) ? dados.familia_membros.map(String) : []);
                this.$set(this.item, 'termo_acolhimento', dados.termo_acolhimento || '');
                this.$set(this.item, 'motivo_acolhimento', Array.isArray(dados.motivo_acolhimento) ? dados.motivo_acolhimento.map(normalize) : []);
                this.$set(this.item, 'desc_motivo_acolhimento', dados.desc_motivo_acolhimento || '');
                this.$set(this.item, 'desc_origem_solicitacao', dados.desc_origem_solicitacao || '');
                this.$set(this.item, 'desc_genero', dados.desc_genero || '');
                this.$set(this.item, 'unidade_acolhimento', dados.unidade_acolhimento || null);
                this.$set(this.item, 'solicitacao_id', dados.id || null);
                this.$set(this.item, 'list_deficiencia', Array.isArray(dados.list_deficiencia) ? dados.list_deficiencia.map(String) : []);

            },

            getUnidades() { 
                this.load = true;
                axios.get("api/dashboard/unidades-interna-externa").then((response) => {
                    this.unidades = response.data.data.map((item) => ({
                        id: item.id,
                        value: item.descricao
                    }));
                });
            },

            submitFile(files) {
                this.files = files;
            },

            formatarCpf(cpf) {
                if (!cpf) return '';

                cpf = String(cpf).replace(/\D/g, '');

                if (cpf.length !== 11) {
                    return cpf;
                }

                return cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    '$1.$2.$3-$4'
                );
            },

            procurarCriancas: function procurarCriancas(search) {
                if (search != "") {
                    clearTimeout(procurarCriancas.timeout);
                    procurarCriancas.timeout = setTimeout(() => {
                    this.loadingCriancas = true;
                    this.$refs.select.openOptions(false);
                    axios
                        .get(
                        `api/dashboard/acolhimento/pesquisar/crianca?q=${escape(
                            search
                        )}&unidade=${this.$route.params.id}`
                        )
                        .then((response) => {
                        this.pessoas = response.data;
                        this.$refs.select.openOptions(true);
                        })
                        .finally(() => {
                        this.$refs.select.closeOptions(false); // erro no console
                        setTimeout(() => {
                            this.loadingCriancas = false;
                            this.$refs.select.openOptions(true);
                        }, 3000);
                        });
                    }, 1000);
                }
            },
            procurarIdosos: function procurarIdosos(search) {
                if (search != "") {
                    clearTimeout(procurarIdosos.timeout);
                    procurarIdosos.timeout = setTimeout(() => {
                    this.loadingIdosos = true;
                    this.$refs.select.openOptions(false);
                    axios
                        .get(
                        `api/dashboard/acolhimento/pesquisar/idoso?q=${escape(
                            search
                        )}&unidade=${this.$route.params.id}`
                        )
                        .then((response) => {
                        this.pessoas = response.data;
                        this.$refs.select.openOptions(true);
                        })
                        .finally(() => {
                        this.$refs.select.closeOptions(false);
                        setTimeout(() => {
                            this.loadingIdosos = false;
                            this.$refs.select.openOptions(true);
                        }, 3000);
                        });
                    }, 1000);
                }
            },
            submit() {

                // Definir unidade_id conforme origem
                if (this.veioGestaoVagas && this.item.unidade_acolhimento) {
                    this.item.unidade_id = this.item.unidade_acolhimento;
                } else {
                    this.item.unidade_id = this.$route.params.id;
                }

                let formData = new FormData();

                for (var i in this.item) {
                    if (i === "tecnicos") {
                        formData.append("tecnicos", JSON.stringify(this.item.tecnicos));
                    } else {
                        formData.append(i, this.item[i]);
                    }
                }

                if (this.files.length > 0 && this.files.length !== undefined) {
                    for (const i of Object.keys(this.files)) {
                        formData.append("anexos[]", this.files[i]);
                    }
                } else {
                    formData.append("anexos", this.files);
                }

                if (this.item.solicitacao_id) {
                    formData.append("solicitacao_id", this.item.solicitacao_id);
                }

                if (this.veioGestaoVagas == false){

                    formData.append("situacao_usuario", this.situacao_usuario);

                }

                let url = "";

                if (this.veioGestaoVagas == true){

                    // CALCULA A IDADE:
                    const hoje = moment();
                    const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
                    const idade = hoje.diff(nascimento, 'years');

                    url =
                        idade < 18
                            ? "api/dashboard/acolhimento/store"
                            : "api/dashboard/acolhimento/idoso/store";

                }else if (this.publico_alvo == "crianca"){

                    url = "api/dashboard/acolhimento/store";

                }else{

                    url = "api/dashboard/acolhimento/idoso/store";

                }

                let ladda = Ladda.create(document.querySelector(".btn-submit"));
                ladda.start();

                axios
                    .post(url, formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: (event) => {
                            let progress = Math.round((event.loaded * 100) / event.total);
                            this.progressCompleted = progress;
                        },
                    })
                    .then((response) => {
                        ladda.stop();
                        this.$snack.success({
                            button: false,
                            text: response.data.data.message,
                        });

                        let redirectUrl = "";

                        if (this.veioGestaoVagas == true){

                            // CALCULA A IDADE:
                            const hoje = moment();
                            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
                            const idade = hoje.diff(nascimento, 'years');
                            
                            redirectUrl =
                                idade < 18
                                    ? `/dashboard/acolhimento/edit/${response.data.data.id}`
                                    : `/dashboard/acolhimento/idoso/edit/${response.data.data.id}`;

                        }else if (this.publico_alvo == "crianca"){

                            redirectUrl = `/dashboard/acolhimento/edit/${response.data.data.id}`;

                        }else{

                            redirectUrl = `/dashboard/acolhimento/idoso/edit/${response.data.data.id}`;

                        }

                        this.$router.push(redirectUrl);
                    })
                    .finally(() => {
                        this.progressCompleted = 0;
                        this.files = [];
                    });
            },
        },
    };
</script>
